import * as React from 'react';
import clsx from 'clsx';
import styles from './input-radio.module.scss';
import { InputProps } from '@/interfaces';

export const InputRadio: React.FC<
	InputProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({
	name,
	register,
	rules,
	children,
	className,
	value,
	defaultChecked,
	hidden,
	...props
}) => {
	return (
		<div className={clsx(className, 'flex items-start justify-start')}>
			<div
				className={clsx(styles.content, 'flex mr-3', {
					hidden: hidden,
				})}
			>
				<input
					className={clsx(styles.checkbox)}
					type="radio"
					id={`${name}-${value}`}
					value={value}
					defaultChecked={defaultChecked}
					{...register(name, rules)}
					{...props}
				/>
				<label htmlFor={`${name}-${value}`}>{name}</label>
			</div>
			<label
				htmlFor={`${name}-${value}`}
				className={clsx(
					'w-full',
					{ 'cursor-not-allowed': props.disabled },
					{ 'cursor-pointer': !props.disabled }
				)}
			>
				{children}
			</label>
		</div>
	);
};
